<template>
    <div id="myAccount">
        <el-table :data="tableData" border>
            <el-table-column prop="typeName" label="账户类型"></el-table-column>
            <el-table-column prop="balanceRmb" label="账户余额（元）"></el-table-column>
            <el-table-column prop="totalHistoryRmb" label="历史总额（元）"></el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="getAccountDataHandler(scope.row)">查看记录</el-button>
                    <el-button type="text" size="small" v-if="scope.row.type == 10" @click="applyVisible = true" >申请提现</el-button>
                      <el-button type="text" size="small" v-if="scope.row.type == 30" @click="applyHaoka()" >申请提现</el-button>
                </template>
            </el-table-column>
        </el-table>  

        <div v-if="showAccount">
            <h3>{{ currentAccount }} - 交易流水</h3>
            <el-table :data="tbpg.tableData" border  >
                <el-table-column prop="accountBalanceRmb" label="账户余额（元）"></el-table-column>
                <el-table-column prop="amountRmb" label="交易金额（元）"></el-table-column>
                <el-table-column prop="createTime" label="交易时间"></el-table-column>
                <el-table-column prop="ioTypeName" label="类型"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg.currentPage"
                :page-sizes="[15, 50, 100, 500]"
                :page-size="tbpg.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg.total">
            </el-pagination>  
        </div>

        <el-dialog :append-to-body="true"  title="提现申请" :visible.sync="applyVisible"  width="500px" @close="cancelToApply()" :close-on-click-modal="false">

            <el-form  ref="withdrawalForm" :model="withdrawalForm" label-width="100px" label-position="left" >
                <el-form-item label="收款账户：" >
                    <el-select v-model="withdrawalForm.withdrawalId" placeholder="请选择收款账户">
                        <el-option
                          v-for="item in withdrawalOptions"
                          :key="item.id"
                          :label="item.cashType==1?'支付宝 - '+item.payeeAccount:'银行卡 - '+item.payeeAccount"
                          :value="item.id">
                        </el-option>
                    </el-select> 
                </el-form-item>

                <el-form-item style="margin-top: 25px;" label="提现金额：" >
                    <el-input placeholder="请输入提现金额" v-model="input1" v-model.trim="withdrawalForm.priceRmb" @keyup="formatPrice()" 
                        @blur="formatPrice()">
                        <template slot="prepend">￥</template>
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>

                <el-form-item style="margin-top: 25px;" label="提现密码：" >
                    <el-input placeholder="请输入密码" v-model="withdrawalForm.paypass" show-password></el-input>
                </el-form-item>
                <el-form-item label="手机号"  prop="userPhone">
                    <el-input  style="width:65%" v-model="bindMobile" disabled></el-input>
                    <el-button  type="primary" :disabled="smsFlag" @click="getSmsCode('changePaypass')" style="width:30%; float: right;">{{changePasswordBtnTxt}}</el-button>
                </el-form-item>

                <el-form-item label="验证码"  prop="smsCode">
                    <el-input v-model="smsCode" ></el-input>
                </el-form-item>
            </el-form>

            <p style="margin-top: 10px; margin-bottom: 50px;color: #606266;">
            最小提现金额{{cashoutMinAmount}}元，单笔手续费 6%，提现金额必须是50的倍数</p>
            <el-button @click="withdrawalForm.priceRmb = allBalanceRmb">全部提现</el-button>
            <el-button @click="cancelToApply()">取 消</el-button>
            <el-button type="primary" @click="applyCashOutHandler()">申 请</el-button>
        </el-dialog> 

    </div>
</template>
<script>
import {getAgentAccount, getAccountData} from '@/api/home.js'
import {applyCashOut } from '@/api/finance.js';
import common from '@/utils/common.js'
import {mapGetters } from "vuex";
export default {
    data(){
        return {
            smsCode:'',
            changePasswordBtnTxt: '获取验证码',
            bindMobile:'',
            tableData: [],
            showAccount: false,            
            currentId: '',
            currentAccount: '',
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            allBalanceRmb: 0,

            applyVisible: false,
            withdrawalOptions: [],
            withdrawalForm:{
                withdrawalId: null,
                priceRmb: '',
                paypass:null,
            },
            ishaoka:false,
            
            cashoutMinAmount: 0,
            cashoutFee: 0,
        }
    },
    methods: {
        applyHaoka(){
            this.ishaoka=true;
            this.applyVisible=true;
        },


        /**  修改提现密码  **/
        getSmsCode(actionName){
            if(actionName=="changePaypass"){
                common.sysRequest('/sms/send', {userPhone:this.bindMobile}, 'post').then(res => {  
                    if(res.data.code == 200){
                        var n = 60;
                        this.changePasswordBtnTxt = n +'s后重新获取';
                        let timer = window.setInterval(() => {   
                            n--;                     
                            this.changePasswordBtnTxt = n +'s后重新获取';
                            if(n < 1){
                                window.clearInterval(timer);
                                this.changePasswordBtnTxt = '获取验证码';
                            }
                        },1000)
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }
           
            
        },
        getAgentAccountHandler(){
            getAgentAccount({}).then(res => {
                if(res.data.code == 200){
                    this.tableData = res.data.data.resultList;

                    for(let i=0; i<res.data.data.resultList.length; i++){
                        if(res.data.data.resultList[i].type==10){
                            this.allBalanceRmb = res.data.data.resultList[i].balanceRmb;
                        }
                    }

                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        getAccountDataHandler(row){
            if(row){
                this.currentId = row.id;
                this.currentAccount = row.typeName;
                this.tbpg.currentPage = 1;
            }
            var data = {
                perPageNum: this.tbpg.pageSize,
                pageNo: this.tbpg.currentPage,
                accountId: this.currentId              
            }
            getAccountData(data).then(res => {
                this.showAccount = true;
                common.listCallback(this, res, 'tbpg');
            })
        },

        applyCashOutHandler(){
            if(Number(this.withdrawalForm.priceRmb) <= 0){
                this.$message.error('请输入提现金额');
                return;
            }
            let data = '';
            if(this.ishaoka==true){
               data= {"priceRmb":Number(this.withdrawalForm.priceRmb),
                        "withdrawalId": this.withdrawalForm.withdrawalId,
                        "paypass": this.withdrawalForm.paypass,
                        "smsCode":this.smsCode,
                        "haoka":"2",
                        "bindMobile":this.bindMobile   };
            }else{
                data={"priceRmb":Number(this.withdrawalForm.priceRmb),
                        "withdrawalId": this.withdrawalForm.withdrawalId,
                        "paypass": this.withdrawalForm.paypass,
                        "smsCode":this.smsCode,
                        "bindMobile":this.bindMobile   };
            }

            this.$confirm('确定要提现吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                applyCashOut(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getAgentAccountHandler();
                        this.cancelToApply();
                    }else{
                        this.$message.error(res.data.message);
                    }
                    
                })
            }).catch(() => {

            });
        },

        formatPrice(){
            this.withdrawalForm.priceRmb = this.withdrawalForm.priceRmb.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        },
        cancelToApply(){
            this.withdrawalForm.priceRmb = '';
            this.withdrawalForm.paypass = "";
            this.applyVisible = false;
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAccountDataHandler();
        },
        handleCurrentChange(val){            
            this.tbpg.currentPage = val;
            this.getAccountDataHandler();
        }
    },
     computed: {


        smsFlag(){
            if(this.bindMobile  && this.changePasswordBtnTxt == '获取验证码'){
                return false;
            }else{
                return true;
            }
        },
        ...mapGetters("menu", {
            hasAuthority: "hasAuthority" 
        }),

    },
    created(){
        this.getAgentAccountHandler();

        common.sysRequest('agent/account/cashout/config', null, 'post').then(res => {
            if(res.data.code == 200){
                this.cashoutMinAmount = res.data.data.cashoutMinAmount;
                this.cashoutFee = res.data.data.cashoutFee;
                this.bindMobile=res.data.data.bindMobile;
            }
        });

        //获取提现方式及收款账户
        common.sysRequest('agent/withdrawal/list', {}, 'post').then(res => {  
            if(res.data.code == 200){
                this.withdrawalOptions = res.data.data.filter(function(item){
                    if(item.enable){
                        return item;
                    }
                });
            }
        });
    },

}
</script>
<style lang="less" scoped>
#myAccount {
    h3 {
        font-size: 13px;
        font-weight: bold;
        padding-left: 5px;
        margin: 20px 0;
        border-left: 3px solid #409eff;
    }

    .withdrawalForm{
        margin-bottom: 30px;
    }
}


</style>
